export default __webpack_public_path__ + "static/media/clicktrades-logo-white.44ee0b8b.svg";